import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {Registrar} from '../types';
import {useNavigate} from "react-router-dom";
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    // Optional: the Add page has no record yet (FNP-943 — React Query types the
    // absent record honestly; the body already guards with `if (record)`).
    record?: Omit<Registrar, 'id'>,
    handleSubmit: (values: Registrar) => void
}) => {
    const navigate = useNavigate()

    const onSubmit = (values: Registrar) => {
        handleSubmit(values);
        navigate('/registrars');
    };

    const onCancel = () => {
        navigate('/registrars');
    };


    let initialValues = {} as Registrar;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
